/*
 * VesselSpecsView
 *
 * Vessel specifications inside the Fleet Explorer's list subcard, toggled by
 * the info icon next to the vessel name. Embeds the planner's VesselSpecTab
 * so both places share the same two tables and the same inline editing.
 * Closed via the info icon or the header's "Back".
 */

import React, { useState } from "react";
import { Box } from "@mui/material";
import NotificationSnackbar from "@/components/ui/NotificationSnackbar";
import VesselSpecTab from "@/features/voyagePlanner/wizard/tabs/VesselSpecTab.jsx";

export default function VesselSpecsView({
  meta,
  vesselLabel,
  vesselId,
}) {
  // Same save confirmation the planner's Options step shows.
  const [savedSnackOpen, setSavedSnackOpen] = useState(false);

  return (
    // mt matches the list view's header→row gap, so Edit sits at the same
    // distance below Back as the Table button does.
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        mt: 0.75,
      }}
    >
      <VesselSpecTab
        vesselMeta={meta}
        vesselLabel={vesselLabel}
        vesselId={vesselId}
        onVesselSaved={() => setSavedSnackOpen(true)}
        showRnwIntro={false}
        showVesselChip={false}
        showWeatherDefaults
        scrollBody
      />
      <NotificationSnackbar
        open={savedSnackOpen}
        message="Vessel data saved successfully"
        autoHideDuration={4000}
        onClose={() => setSavedSnackOpen(false)}
      />
    </Box>
  );
}
